export enum OrdersRouteNames {
  ORDERS_ROOT = 'OrdersRoot',
  ORDER_LIST = 'OrdersRoot/List',
  ORDER_DETAILS = 'OrdersRoot/Details',
  ORDER_DETAILS_MORE_INFO = 'OrdersRoot/Details/MoreInfo',
  ORDER_DETAILS_REFUND = 'OrdersRoot/Details/Refund',
  ORDER_NOT_FOUND = 'OrdersRoot/Details/NotFound',
  ORDER_ENTITY = 'OrdersRoot/Entity',
}
